import { graphql } from "react-relay";
import { CalendarProfile } from "./CalendarProfile";
import { ProfileTimeVisualizations } from "@components/profile-time-visualizations";
import { ProfileCollaborators } from "@components/profile-collaborators";
import { WeekInReviewScrubber } from "@components/week-in-review-scrubber";
import { WeekInReviewNotAvailable } from "@components/week-in-review-not-available";

export const fragments = {
  org: graphql`
    fragment CalendarProfile_org on Org
    @argumentDefinitions(
      calendarId: { type: "String!" }
      calendarIds: { type: "[String]!", defaultValue: [] }
      timeZone: { type: "String!" }
      rangeMin: { type: "DayTimeSlotInput!" }
      rangeMax: { type: "DayTimeSlotInput!" }
      showWeekInReview: { type: "Boolean!" }
      week: { type: "String!" }
    ) {
      id
      experiments
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          list {
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
            isUser
            userId
            ...WeekInReviewNotAvailable_person
          }
        }
        ... on GraphEntityError {
          message
        }
      }
      ...ProfileTimeVisualizations_org
        @arguments(
          calendarId: $calendarId
          timeZone: $timeZone
          rangeMin: $rangeMin
          rangeMax: $rangeMax
        )
      ...ProfileCollaborators_orgRefetch @arguments(calendarIds: $calendarIds)
      ...ProfileCollaborators_org
        @arguments(
          calendarId: $calendarId
          timeZone: $timeZone
          rangeMin: $rangeMin
          rangeMax: $rangeMax
        )
      rewindHistoryErrorable(calendarId: $calendarId, week: $week) @include(if: $showWeekInReview) {
        __typename
        ... on GraphEntityError {
          message
          statusCode
        }
        ... on RewindHistory {
          ...WeekInReviewScrubber_rewindHistory
        }
      }
      ...WeekInReviewNotAvailable_org
    }
  `,
};

export const query = graphql`
  query CalendarProfileRefetchQuery(
    $orgRelayId: ID!
    $calendarId: String!
    $calendarIds: [String]!
    $timeZone: String!
    $rangeMin: DayTimeSlotInput!
    $rangeMax: DayTimeSlotInput!
    $showWeekInReview: Boolean!
    $week: String!
  ) {
    node(id: $orgRelayId) {
      id
      ... on Org {
        ...CalendarProfile_org
          @arguments(
            calendarId: $calendarId
            calendarIds: $calendarIds
            timeZone: $timeZone
            rangeMin: $rangeMin
            rangeMax: $rangeMax
            showWeekInReview: $showWeekInReview
            week: $week
          )
      }
    }
  }
`;
